import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import StripePricingTable from '../components/plan-selection/StripePricingTable';

const meta = {
  title: 'Choose Your Plan - Ordio',
  meta: [],
  link: [],
  style: [],
  script: [
    {
      src: 'js/global-2274.js',
    },
  ],
};

export default function StripePricing() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <StripePricingTable />
    </React.Fragment>
  );
}
